import styles from './index.module.scss';

import { FC, useEffect, useState } from 'react';

interface NeedId {
  costPerSquareFoot: number;
  totalSquareFoot: number;
  label: string;
}

interface Fields {
  needId?: NeedId;
  squareFeet?: number;
}

export const Estimate: FC = () => {
  const [fields, setFields] = useState<Fields>({});

  useEffect(() => {
    setFields((prevFields) => ({
      ...prevFields,
      ...JSON.parse(sessionStorage.getItem('fields') || '{}')
    }));
  }, []);

  return (
    <>
      {fields.needId && (
        <div className={styles['estimate']}>
          <p>
            Estimated cost:{' '}
            <strong>
              ${fields.needId.costPerSquareFoot * (fields.squareFeet || fields.needId.totalSquareFoot)}
              <sup>*</sup>
            </strong>
          </p>
          <p>
            <em>
              Estimate based on national average of ${fields.needId.costPerSquareFoot} per square foot for a {fields.squareFeet || fields.needId.totalSquareFoot} square foot{' '}
              {fields.needId.label.toLowerCase()} roof. This is not a quote. Actual price may vary.
            </em>
          </p>
        </div>
      )}
    </>
  );
};
